// hooks/useNationalLanguage.jsx
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cookies } from '../shared/cookies.js';
import { useLocation } from "react-router-dom";

export default function useNationalLanguage() {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState('en');
  const location = useLocation();

  const normalizeLanguage = (rawLang) => {
    const candidate = String(rawLang || '').trim().toLowerCase();
    const supported = Object.keys(i18n?.options?.resources || {});
    return supported.includes(candidate) ? candidate : 'en';
  };

  const detectLanguage = () => {
    const cookieLang = Cookies.get('national_market');
    if (cookieLang) return normalizeLanguage(cookieLang);

    if (location.pathname.includes("/shop/check/")) return 'vi'; // ✅ sửa ở đây
    return 'en';
  };

  useEffect(() => {
    const currentLang = detectLanguage();

    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }

    setLang(currentLang);

    const handleLanguageChanged = (newLang) => setLang(normalizeLanguage(newLang));
    i18n.on('languageChanged', handleLanguageChanged);

    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n, location.pathname]);

  return { i18n, lang };
}
